// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE

import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.landing = (await import('./pages/LandingPage')).LandingPage;
  }
  return Components;
};

export const getRoutes = (
  currentRouteName,
  currentRouteComponent,
  serverPages,
) => ({
  landing: {
    name: 'LandingPage',
    componentName: 'LandingPage',
    chunk: () => import('./pages/LandingPage'),
    get component() {
      return ssr
        ? serverPages.landing
        : currentRouteName === 'LandingPage'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.LandingPage,
              })),
            );
    },
    path: '/:context?/military/discount',
    prefetch: ['verification'],
    channel: null,
  },
});
